import { useId, useState } from "react";

const items = [
  {
    q: "How do you make money if there's no markup?",
    a: "Annual membership: Basic $29.99/yr, Pro $49.99/yr, Family $79.99/yr. No markup, no supplier kickbacks, no inflated nightly rates.",
  },
  {
    q: "Are the prices really always lower than Booking / Kayak / Expedia?",
    a: "Not always. Members pay the supplier's price, with no markup. On some routes another site can still be cheaper.",
  },
  {
    q: "Can I cancel membership anytime?",
    a: "Any time, from your profile. Existing bookings keep their zero-markup pricing, we don't claw savings back when you leave.",
  },
  {
    q: "Is the AI just a wrapper around an LLM?",
    a: "No. Our agents run on Claude, with OpenAI as fallback, prompted on travel-specific structured outputs and grounded in airline and hotel APIs. The pricing engine plugs directly into supplier feeds; the LLM is an interface, not the product.",
  },
];

export function FAQ() {
  const [open, setOpen] = useState<number>(0);
  const baseId = useId();
  return (
    <section className="sec" id="faq">
      <div className="section-head" style={{ textAlign: "center", margin: "0 auto" }}>
        <div className="eyebrow" style={{ justifyContent: "center", display: "inline-flex" }}>
          <span className="dot" /> Common questions
        </div>
        <h2 style={{ textAlign: "center" }}>
          Things people <em>actually</em> ask.
        </h2>
      </div>
      <div className="faq-list" role="list">
        {items.map((it, i) => {
          const isOpen = open === i;
          const panelId = `${baseId}-panel-${i}`;
          const buttonId = `${baseId}-button-${i}`;
          return (
            <div key={i} className={`faq-item${isOpen ? " open" : ""}`} role="listitem">
              <button
                type="button"
                id={buttonId}
                className="faq-q"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? -1 : i)}
              >
                <span>{it.q}</span>
                <span className="plus" aria-hidden="true">
                  +
                </span>
              </button>
              <div
                id={panelId}
                role="region"
                aria-labelledby={buttonId}
                className="faq-a"
              >
                {it.a}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
